import axios from 'axios'
import baseService from './baseService'
import appraisalData from './data/appraisal'
import carFaxData from './data/carfax'
import autoCheckData from './data/autocheck'

const appraisalService = {
  appraise (vinNo, trim, mileage, condition, msrp) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/appraise?vin=' + vinNo + '&trim=' + trim
      if (mileage) {
        serviceUrl += '&mileage=' + mileage
      }
      if (condition) {
        serviceUrl += '&condition=' + condition
      }
      if (msrp) {
        serviceUrl += '&msrp=' + msrp
      }
      if (baseService.isTestMode) {
        resolve(appraisalData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCarFax (vinNo, currentDealer) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getcarfax?vin=' + vinNo + '&did=' + currentDealer.id
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getAutoCheck  (vinNo, currentDealer) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getautocheck?vin=' + vinNo + '&did=' + currentDealer.id
      if (baseService.isTestMode) {
        resolve(autoCheckData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getAutoCheckReport  (vinNo, currentDealer) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getautocheckreport?vin=' + vinNo + '&did=' + currentDealer.id
      if (baseService.isTestMode) {
        resolve(autoCheckData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  },
  generateCarFaxReportPdf (vinNo) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/carfaxreportgenerate?vinno=' + vinNo
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  generateAutoCheckReportPdf (vinNo) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/autocheckreportgenerate?vinno=' + vinNo
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getBlackBookInformation (vinNo, currentDealer) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getblackbookbyvin?vin=' + vinNo + '&dealerId=' + currentDealer.id
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCarFaxLoginUrl (userId) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getcarfaxloginurl?userId=' + userId
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getVehicleCarFaxUrlByVin (userId, vinNo) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/getVehicleCarFaxUrlByVin?userId=' + userId + '&vinNo=' + vinNo
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  carFaxReportUrlGeneratePdf  (userId, carFaxUrl, vinNo, inventoryId) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/carFaxReportUrlGeneratePdf?userId='+ userId + '&carfaxUrl=' + carFaxUrl + '&vinNo=' + vinNo + '&inventoryId=' + inventoryId
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  extractCarfaxRatingFromDealerReport (userId, vinNo, purchaseIfRequired, inventoryId, includeHistory = true) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/extractCarfaxRatingFromDealerReport?userId=' + userId + '&vinNo=' + vinNo + '&purchaseIfRequired=' + purchaseIfRequired + '&inventoryId=' + inventoryId
      //⚠ Appended ONLY when a caller turns the history off (the RO screens, which never use it), so every
      //other caller keeps sending exactly the URL it always did. The server defaults to including it.
      if (includeHistory === false) {
        serviceUrl += '&includeHistory=false'
      }
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  logoutCarfaxSession (userId) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/logoutCarfaxSession?userId=' + userId
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .post(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  addCarFaxReport (userId, carFaxModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
        .post('/appraisal/addCarfaxRating?userId=' + userId + '&inventoryId=' + carFaxModel.inventoryId + '&vinNo=' + carFaxModel.vinNo + '&dealerReportUrl=' + carFaxModel.dealerReportUrl + '&reportExpiresAt=' + carFaxModel.reportExpiresAt, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
      }
    })
  },
  extractDetailedHistoryFromCarfaxDealerReport (fileUrl, vinNo, inventoryId) {
    return new Promise((resolve, reject) => {
      var serviceUrl = '/appraisal/extractDetailedHistoryFromCarfaxDealerReport?fileUrl=' + fileUrl + '&vinNo=' + vinNo + '&inventoryId=' + inventoryId
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
          .get(serviceUrl, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  extractCarfaxRatingFromDealerReportUrl (userId, carFaxModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(carFaxData)
      } else {
        axios
        .post('/appraisal/extractCarfaxRatingFromDealerReportUrl?userId=' + userId + '&inventoryId=' + carFaxModel.inventoryId + '&vinNo=' + carFaxModel.vinNo + '&dealerReportUrl=' + carFaxModel.dealerReportUrl + '&reportExpiresAt=' + carFaxModel.reportExpiresAt, baseService.defaultConfig)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response.data)
        })
      }
    })
  }
}

export default appraisalService
